<template>
    <div style="background-color:rgb(250,250,250);">
        <v-container style="padding: 10px;">
            <h2 class="pt-5">Support</h2>
            <h2>Deploy your own Ride Hailing Network</h2>
            Does your organization or municipality want to implement an easy ride hailing program?
            <br />
            Many small locales do not have public transit and are looking for ways to schedule and administer a drive network.

            <h2>openride...</h2>
            consists of a client and driver mobile app and the openride administration dashboard.
            <br />
            With it
            <br />
            You can provide better services to your clients and track your fleet of drivers and appointments.

            <h2>FAQ</h2>
            How do I get started ?
            <br />
            First, create an 
            <router-link to="/login">account</router-link>, which only takes a few seconds.

        </v-container>
        <v-footer class="pa-3">
            <v-container fluid class="text-xs-center">
            </v-container>
        </v-footer>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style>
</style>
